import React from 'react';
import BossDialog from '../../../components/BossDialog';
import { useTranslation } from '../../../locale/useTranslation';

const AssignNewTransmissionIdResponsePopup = (props) => {
    const { onClose, selectedItems = [], updatedData = [] } = props;
    const lang = useTranslation();

    return (
        <BossDialog title={lang.updated_transmission_id_dialogue_header} width={"750px"} onClose={onClose}>
            <div className="row mt-2">
                <div className="col-12">
                    <div style={{ maxHeight: '50vh', overflowY: 'auto', overscrollBehavior: 'contain' }}>
                        <table className="table table-sm table-bordered table-hover mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#e9ecef', backgroundClip: 'padding-box', boxShadow: 'inset 0 -1px 0 #dee2e6' }}>{lang.title_label}</th>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#e9ecef', backgroundClip: 'padding-box', boxShadow: 'inset 0 -1px 0 #dee2e6' }}>{lang.catchup_label}</th>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#e9ecef', backgroundClip: 'padding-box', boxShadow: 'inset 0 -1px 0 #dee2e6' }}>{lang.old_transmission_id_label}</th>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#e9ecef', backgroundClip: 'padding-box', boxShadow: 'inset 0 -1px 0 #dee2e6' }}>{lang.new_transmission_id_label}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedItems.map((item, idx) => {
                                    const updatedItem = updatedData.find(x => x._id === item._id);
                                    const updatedCSID = updatedItem?.updatedTransmissionId ?? "";

                                    return (
                                        <tr key={idx}>
                                            <td style={{ fontWeight: '500' }}>
                                                {item.Title ?? ""}
                                            </td>
                                            <td style={{ fontWeight: '500' }}>
                                                {item?.IsCatchUp ? "TRUE" : "FALSE"}
                                            </td>
                                            <td style={{ fontFamily: 'monospace' }}>
                                                {item.CSID ?? ""}
                                            </td>
                                            <td style={{ fontWeight: 'bold', color: '#28a745', fontFamily: 'monospace' }}>
                                                {updatedCSID}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-3 ml-2" style={{ fontSize: "13px" }}>
                        <strong>Note:</strong> Submit the latest EPG. For CatchUp events : Publish to VOD, Submit the latest EPG, Submit Incremental.
                    </div>
                </div>
            </div>
        </BossDialog>
    );
};

export default AssignNewTransmissionIdResponsePopup;
